import { render } from "./InstitutionAnalytics.vue?vue&type=template&id=b75dce2e&lang=pug"
import script from "./InstitutionAnalytics.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutionAnalytics.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__